import React from 'react';
import { Button, Grid } from 'ui-toolkit';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface JournalEntriesNavigationProps {
  disableCreate: boolean;
  isShowingDeleted: boolean;
  queryString: String;
  onNew: () => void;
}

const ToggleDeletedEntriesButton = styled(Button)`
  ${(props) => (props.intent === 'secondary' ? `color: ${props.theme.colors.darkGray}` : ``)};
`;

export const JournalEntriesNavigation: React.FC<JournalEntriesNavigationProps> = ({
  disableCreate,
  isShowingDeleted,
  queryString,
  onNew,
}) => (
  <Grid templateColumns="max-content max-content">
    <Button intent="primary" onClick={onNew} disabled={disableCreate}>
      New Journal Entry
    </Button>
    <Link
      to={
        isShowingDeleted
          ? `/spa/admin/accounting/journal_entries${queryString}`
          : `/spa/admin/accounting/journal_entries/deleted${queryString}`
      }
    >
      <ToggleDeletedEntriesButton intent={isShowingDeleted ? 'secondary' : 'ghost'} type="button">
        {isShowingDeleted ? 'Show Active Entries' : 'Show Deleted Entries'}
      </ToggleDeletedEntriesButton>
    </Link>
  </Grid>
);
